import ReportTable from '../../../../../components/Grid/ReportTable';

export default function ProspectsTable(props: any) {
  return <ReportTable model={props.model} columnCount={9} />;
}
